<div class="switch slds-form-element">
  <label class="slds-checkbox_toggle slds-grid">
    <span class="slds-form-element__label slds-m-bottom_none">{{label}}</span>
    <input type="checkbox" [checked]="defaultChecked" (change)="onSwitchChange($event)" name="checkbox-toggle-15" value="checkbox-toggle-15"
      aria-describedby="checkbox-toggle-15" />
    <span id="checkbox-toggle-15" class="slds-checkbox_faux_container">
      <span class="slds-checkbox_faux"></span>
    </span>
  </label>
</div>